/*
 * @Author: your name
 * @Date: 2020-05-12 10:54:37
 * @LastEditTime: 2020-07-18 12:09:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_dev\src\assets\js\callMobile.js
 */ 
export default {
    install(Vue) {
        Vue.prototype.$callMobile = function (handlerInterface, handlerMethod, parameters) {
            // handlerInterface由iOS addScriptMessageHandler与andorid addJavascriptInterface 代码注入而来。
            const dic = { handlerInterface: handlerInterface, function: handlerMethod, parameters: parameters };
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                window.webkit.messageHandlers[handlerInterface].postMessage(dic);
            } else {
                // 安卓传输不了js json对象
                // eslint-disable-next-line no-lonely-if
                if (typeof window[handlerInterface][handlerMethod] === 'function') {
                    if (parameters !== '' && parameters !== null && typeof parameters !== 'undefined') {
                        window[handlerInterface][handlerMethod](JSON.stringify(dic));
                    } else {
                        window[handlerInterface][handlerMethod]();
                    }
                }
            }
        };
    },
};
